<template>
	<div id="Convenientservice" class="pub_pub">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/bmfw.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/bmfw_font.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>便民</span><span style="color:#D7230C;">服务</span></div>
					<div class="sm_pub">方便快捷的服务入口</div>
				</div>
			</div>
		</div>
		<div style="box-shadow: 0 4px 24px rgba(0,0,0,.16);margin-top: 10px;" class="pub_lb bmfw_warp__">
			<div class="bmfw_open" v-show="isShowbmfw == 'shfw'">
				<div class="pbu_open_warp">
					<div class="pbu_cont">
						<div class="pbu_titl_img">
							<img src="../imges/bm/shfw_open_1.png" alt="">
						</div>
						<div class="pbu_titl_t">组织服务</div>
						<span href="" @click="GBSHOW" style="    position: absolute;
		right: 3vh;
		font-size: 50px;
		color: #FFF;">×</span>
					</div>
				</div>
				<div class="fl___">
					<div class="fl_lisy">
						<div class="tb_tb">
							<img src="../imges/bm/qy.png" alt="">
						</div>
						<div class="qy_tb" @click="hfcz">中国造船学会</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/qy.png" alt="">
						</div>
						<div class="qy_tb" @click="yljk">中国船舶协会</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/qy.png" alt="">
						</div>
						<div class="qy_tb" @click="shjf">中国船东协会</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/qy.png" alt="">
						</div>
						<div class="qy_tb" @click="jtcx">中国航海学会</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/qy.png" alt="">
						</div>
						<div class="qy_tb" @click="hyxh">中国海洋学会</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/qy.png" alt="">
						</div>
						<div class="qy_tb" @click="gkxh">中国港口协会</div>
					</div>
				</div>
			</div>
			<div @click="gbShowxy('shfw')" class="bmfw_pub" :class="{'bmfw_pub1':isShowbmfw1}"
				v-show="isShowbmfw != 'shfw'">
				<div class="img_lo">
					<img src="../imges/bm/shfw.png" alt="">
				</div>
				<div class="tit_tit">组织服务</div>
				<div class="fl_tit">
					<div class="text_right" style="color: #999999;">中国造船学会</div>
					<div class="text_left" style="color: #999999;">中国船舶协会</div>
					<div class="text_right" style="color: #999999;">中国船东协会</div>
					<div class="text_left" style="color: #999999;">中国航海学会</div>
					<div class="text_left" style="color: #999999;">中国海洋学会</div>
					<div class="text_left" style="color: #999999;">中国港口协会</div>
				</div>
			</div>
			<div class="bmfw_open" v-show="isShowbmfw == 'qyfw'">
				<div class="pbu_open_warp">
					<div class="pbu_cont">
						<div class="pbu_titl_img">
							<img src="../imges/bm/qyyq_open.png" alt="">
						</div>
						<div class="pbu_titl_t">企业服务</div>
						<span href="" @click="GBSHOW" style="   position: absolute;
		right: 3vh;
		font-size: 50px;
		color: #FFF;">×</span>
					</div>
				</div>
				<div class="fl___">
					<div class="fl_lisy">
						<div class="tb_tb">
							<img src="../imges/bm/sjfw.png" alt="">
						</div>
						<div class="qy_tb" @click="qyzc">设计服务 </div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/hhbz.png" alt="">
						</div>
						<div class="qy_tb" @click="qydw">船海标准</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/cjrz.png" alt="">
						</div>
						<div class="qy_tb" @click="zlsb">船检认证</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/hshz.png" alt="">
						</div>
						<div class="qy_tb" @click="zzbl">海事会展</div>
					</div>
				</div>
			</div>
			<div @click="gbShowxy('qyfw')" class="bmfw_pub" :class="{'bmfw_pub1':isShowbmfw1}"
				v-show="isShowbmfw != 'qyfw'">
				<div class="img_lo">
					<img src="../imges/bm/qy_qy.png" alt="">
				</div>
				<div class="tit_tit">企业服务</div>
				<div class="fl_tit">
					<div class="text_right" style="color: #999999;">设计服务</div>
					<div class="text_left" style="color: #999999;">船海标准</div>
					<div class="text_right" style="color: #999999;">船检认证</div>
					<div class="text_left" style="color: #999999;">海事会展</div>
				</div>
			</div>
			<div class="bmfw_open" v-show="isShowbmfw == 'pwfw'">
				<div class="pbu_open_warp">
					<div class="pbu_cont">
						<div class="pbu_titl_img">
							<img src="../imges/bm/pwfw_open_1.png" alt="">
						</div>
						<div class="pbu_titl_t">海事服务</div>
						<span href="" @click="GBSHOW" style="    position: absolute;
		right: 3vh;
		font-size: 50px;
		color: #FFF;">×</span>
					</div>
				</div>
				<div class="fl___">
					<div class="fl_lisy">
						<div class="tb_tb">
							<img src="../imges/bm/zghsj.png" alt="">
						</div>
						<div class="qy_tb" @click="dgjp">中国海事局</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/hsfwzx.png" alt="">
						</div>
						<div class="qy_tb" @click="dgmp">中国海事中心</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/sshyzx.png" alt="">
						</div>
						<div class="qy_tb" @click="dgcp">上海航运中心</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/hygc.png" alt="">
						</div>
						<div class="qy_tb" @click="dgjd">海洋观测</div>
					</div>
				</div>
			</div>
			<div @click="gbShowxy('pwfw')" class="bmfw_pub" :class="{'bmfw_pub1':isShowbmfw1}"
				v-show="isShowbmfw != 'pwfw'">
				<div class="img_lo">
					<img src="../imges/bm/pwfw.png" alt="">
				</div>
				<div class="tit_tit">海事服务</div>
				<div class="fl_tit">
					<div class="text_right" style="color: #999999;">中国海事中心</div>
					<div class="text_left" style="color: #999999;">上海航运中心</div>
					<div class="text_right" style="color: #999999;">中国海事局</div>
					<div class="text_left" style="color: #999999;">海洋观测</div>
				</div>
			</div>
			<div class="bmfw_open" v-show="isShowbmfw == 'qtfw'">
				<div class="pbu_open_warp">
					<div class="pbu_cont">
						<div class="pbu_titl_img">
							<img src="../imges/bm/qtfw_open_1.png" alt="">
						</div>
						<div class="pbu_titl_t">平台服务</div>
						<span href="" @click="GBSHOW" style="    position: absolute;
		right: 3vh;
		font-size: 50px;
		color: #FFF;">×</span>
					</div>
				</div>
				<div class="fl___">
					<div class="fl_lisy">
						<div class="tb_tb">
							<img src="../imges/bm/qtfw_open_2.png" alt="">
						</div>
						<div class="qy_tb" @click="hscx">船海企业地图</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/qtfw_open_3.png" alt="">
						</div>
		 			<div class="qy_tb" @click="dhdt">船舶在线海图</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/qtfw_open_2.png" alt="">
						</div>
						<div class="qy_tb" @click="zhyy">船舶油水系统</div>
					</div>
					<div>
						<div class="tb_tb">
							<img src="../imges/bm/qtfw_open_5.png" alt="">
						</div>
						<div class="qy_tb" @click="hdbm">船舶拍卖出售</div>
					</div>
				</div>
			</div>
			<div @click="gbShowxy('qtfw')" class="bmfw_pub" :class="{'bmfw_pub1':isShowbmfw1}"
				v-show="isShowbmfw != 'qtfw'">
				<div class="img_lo">
					<img src="../imges/bm/qtfw.png" alt="">
				</div>
				<div class="tit_tit">平台服务</div>
				<div class="fl_tit">
					<div class="text_right" style="color: #999999;">船海企业地图</div>
					<div class="text_left" style="color: #999999;">船舶在线海图</div>
					<div class="text_right" style="color: #999999;">船舶油水系统</div>
					<div class="text_left" style="color: #999999;">船舶拍卖出售</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShowbmfw: 'aaa',
				isShowbmfw1: false,
			}
		},
		methods: {
			// 控制器
			gbShowxy(val) {
				this.isShowbmfw = val
				this.isShowbmfw1 = true
			},
			GBSHOW() {
				this.isShowbmfw = 'val'
				this.isShowbmfw1 = false
			},
			hfcz() {
				window.open('http://www.csname.org.cn')
			},
			yljk() {
				window.open(' http://www.cansi.org.cn')
			},
			shjf() {
				window.open('http://www.csoa.cn')
			},
			jtcx() {
				window.open('http://www.cinnet.cn')
			},
			hyxh() {
				window.open('http://www.cso.org.cn')
			},
			gkxh() {
				window.open('http://www.port.org.cn')
			},
			qyzc() {
				window.open('http://www.bestwaysh.com')
			},
			qydw() {
				window.open('http://www.msckobe.com/links/gb.htm')
			},
			zlsb() {
			 window.open('https://www.ccs.org.cn')
			},
			zzbl() {
				window.open(
					'https://www.marintecchina.com/zh-hans/'
				)
			},
			dgjp() {
				window.open(
					'https://www.msa.gov.cn/'
				)
			},
			dgmp() {
				window.open(
					' https://www.cmaritime.com.cn'
				)
			},
			dgcp() {
				window.open('https://www.shisc.net')
			},
			dgjd() {
				window.open('http://www.fjhyyb.cn')
			},
			hscx() {
				window.open('https://www.shipoe360.com/#/VRmap/detail')
			},
			dhdt() {
				window.open('https://www.hifleet.com')
			},
			zhyy() {
				window.open('https://www.joystc.com/chuanbo/#/login')
			},
			hdbm() {
				window.open('http://www.shipinter.com')
			},
		},

	}
</script>

<style>
	#Convenientservice {
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
	}

	/* 头部 */
	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
	}

	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.img_logo>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub>ul::after {
		content: '';
		display: block;
		clear: both;
	}

	.sm_pub {
		float: left;
		margin-left: 40px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.ct_title {
		float: left;

	}

	.ct_img {
		float: left;
		margin-left: 10px;
	}

	.ct_img>img {
		width: 12px;
		height: 10px;
	}

	.ckgd {
		float: right;
		margin-right: 20px;
		color: #999999;
		font-size: 15px;
		height: 36px;
		line-height: 46px;
		cursor: pointer;
	}

	/* 结尾 */

	.xtiao::after,
	.qzzp_title::after,
	.bmfw_warp__::after,
	.djgksp::after,
	.pub_lb::after {
		content: '';
		display: block;
		clear: both;
	}

	.bmfw_pub {
		position: relative;
		float: left;
		width: calc((100% - 120px) / 4);
		cursor: pointer;
		height: 325px;
		border: 1px solid #cecece;
		margin-left: 24px;
		margin-top: 14px;
		margin-bottom: 14px;
		border-radius: 6px;
	}

	.img_lo {
		position: absolute;
		    top: 46px;
		    width: 60px;
		    height: 60px;
		    border-radius: 50%;
		    box-shadow: #6e6e6e 0px 0px 10px;
		    margin-left: calc((100% - 99px) / 2);
		    padding: 20px;
	}

	.bmfw_pub img {
		width: 100%;
		height: 100%;
	}

	.tit_tit {
		font-size: 18px;
		font-weight: 600;
		position: absolute;
		top: 170px;
		width: 100%;
		text-align: center;
	}

	.fl_tit::after {
		content: '';
		display: block;
		clear: both;
	}


	.fl_tit {
		position: absolute;
		top: 220px;
		width: 100%;
	}

	.fl_tit>div {
		width: 45%;
		margin-bottom: 15px;
		font-size: 15px;
	}


	.text_left {
		float: right;
		text-align: left;
	}

	.text_right {
		float: left;
		text-align: right;
	}

	.bmfw_pub1 {
		width: calc((100% - 120px) / 5);
	}

	.bmfw_open:hover {
		box-shadow: 0px 10px 9px #333;
	}

	.bmfw_open {
		float: left;
		width: calc(((100% - 120px) / 5)*2);
		border: 1px solid #cecece;
		margin-top: 14px;
		margin-bottom: 14px;
		border-radius: 6px;
		margin-left: 24px;
	}

	.pbu_cont::after,
	.pbu_open_warp::after {
		content: '';
		display: block;
		clear: both;
	}

	.pbu_open_warp {
		position: relative;
		width: 100%;
		height: 50px;
		line-height: 60px;
		background-color: #d7230c;
		color: #fff;
		border-radius: 6px;
	}

	.pbu_cont {
		width: 166px;
		margin-left: calc((100% - 168px) / 2);
	}

	.pbu_titl_img {
		float: left;
		width: 40px;
		height: 40px;
		margin-top: 10px;
		overflow: hidden;
	}

	.pbu_titl_img>img {
		width: 100%;
		height: 80%;
		margin-top: -28px;
	}

	.pbu_titl_t {
		float: left;
		font-size: 20px;
		font-weight: 600;
		height: 40px;
		line-height: 40px;
		margin-top: 10px;
		margin-left: 10px;
		letter-spacing: 8px;
	}

	.fl___ {
		height: 274px;
	}

	.fl___>div {
		position: relative;
		float: left;
		height: 30%;
		width: 50%;
		cursor: pointer;
	}

	.tb_tb {
		height: 40px;
		width: 40px;
		position: absolute;
		top: 40%;
		overflow: hidden;
		margin-left: calc((100% - 140px)/2);
	}

	.tb_tb>img {
		width: 100%;
		height: 100%;
	}

	.qy_tb {
		position: absolute;
		top: 40%;
		font-size: 16px;
		height: 40px;
		line-height: 40px;
		width: 120px;
		font-weight: 700;
		letter-spacing: 3px;
		margin-left: calc((100% - 40px)/2);
	}
</style>
